import { render, staticRenderFns } from "./WOverlay.vue?vue&type=template&id=9334b3f4&scoped=true&"
import script from "./WOverlay.vue?vue&type=script&lang=js&"
export * from "./WOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9334b3f4",
  null
  
)

export default component.exports